import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import * as styles from './navItem.module.scss';

const Item = (props) => {
  return (
    <Link
      to={props.href}
      className={classnames(
        props.className,
        styles.item,
        'cr-link cr-subheader-2'
      )}
    >
      {props.text}
    </Link>
  );
};

export default Item;
